import { IResourceComponentsProps, useTranslate } from "@pankod/refine-core";
import{ useState } from 'react';
// import React, { useState } from 'react';
import {
    Create,
    Form,
    Input,
    InputNumber,
    Checkbox,
    Select,
    useForm,
    useSelect,
    // Avatar,
    Row,
    Col,
    // Typography,
    // Space,
    Radio,
    Icons,
    Space,
    // InputProps,
} from "@pankod/refine-antd";

// import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';

// import InputMask from "react-input-mask";
import { IStore, IOrganization, IRoom, ICategory } from "interfaces";

// const { Text } = Typography;

export const StoreCreate: React.FC<IResourceComponentsProps> = () => {
  const t = useTranslate();
  const { formProps, saveButtonProps, queryResult } = useForm<IStore>();
  const { selectProps: organizationSelectProps } = useSelect<IOrganization>({
    resource: "organizations",
  });
  const { selectProps: roomSelectProps } = useSelect<IRoom>({
    resource: "rooms",
  });
  const { selectProps: categorySelectProps } = useSelect<ICategory>({
    resource: "categories",
  });

  const [componentDisabled, setComponentDisabled] = useState<boolean>(false);

    // const onFormLayoutChange = ({ disabled }: { disabled: boolean }) => {
  //   // console.log("onFormLayoutChange", disabled);
  //   // console.log("componentDisabled", componentDisabled);
  //   setComponentDisabled(disabled);
  // };

  const isSuperAdmin = true;

  return (
    <Create
      resource="stores"
      isLoading={queryResult?.isFetching}
      saveButtonProps={saveButtonProps}
    >
      <Form
        {...formProps}
        layout="vertical"
        // onValuesChange={onFormLayoutChange}
        // disabled={componentDisabled}
        initialValues={{
            ftp_login: "",
            ftp_password: "",
            auth_login: "",
            auth_pass: "",
            is_active: true,
            is_ftp: false,
            delete_file: 90,
            update_interval: 60,
            status: "Disconnected",
        }}
      >
        <Row gutter={[64, 0]} wrap>
          <Col xs={24} lg={8}>
            <Form.Item
              label={t("stores.fields.title")}
              name="title"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label={t("stores.fields.organizations")}
              // name={["organizationId", "id"]}
              name="organization_id"
              rules={[{ required: true }]}
            >
              <Select {...organizationSelectProps} />
            </Form.Item>
          </Col>
          <Col xs={24} lg={8}>
            <Form.Item
              label={t("stores.fields.codeId")}
              name="code_id"
              rules={[{ type: "number" }]}
            >
              <InputNumber style={{ width: "100%" }} />
            </Form.Item>
            <Form.Item
              label={t("stores.fields.code")}
              name="code"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>           
          </Col>
          <Col xs={24} lg={8}>
            <Form.Item
              label={t("stores.fields.room")}
              // name={["organizationId", "id"]}
              name="room_id"
            >
              <Select {...roomSelectProps} />
            </Form.Item>
            <Form.Item
              label={t("stores.fields.category")}
              // name={["organizationId", "id"]}
              name="category_id"
            >
              <Select {...categorySelectProps} />
            </Form.Item>
          </Col>
        </Row>
        {isSuperAdmin && (
        <Row gutter={[64, 0]} wrap>
          <Col xs={24} lg={8}>
            <Form.Item label={t("stores.fields.dateFormat")} name="date_format">
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} lg={8}>
            <Form.Item
              label={t("stores.fields.updateInterval")}
              name="update_interval"
              rules={[{ type: "number" }]}
            >
              <InputNumber style={{ width: "100%" }} />
            </Form.Item>
          </Col>
          <Col xs={24} lg={8}>
          <Form.Item
              label={t("stores.fields.deleteFile")}
              name="delete_file"
              rules={[{ type: "number" }]}
            >
              <InputNumber style={{ width: "100%" }} />
            </Form.Item>
          </Col>
        </Row>
        )}
        <Row gutter={[64, 0]} wrap>
        <Col xs={24} lg={24}>
            <label>{t("stores.fields.loading_data")}</label>
        </Col>
            <Col xs={24} lg={8}>
                <Form.Item
                    name="is_ftp"
                    valuePropName="checked"
                >
                    <input type={"checkbox"} id='ftp'
                           checked={componentDisabled}
                           onChange={e => setComponentDisabled(e.target.checked)}/>
                    <label htmlFor={"ftp"}> {t("stores.mode.ftp")}</label>
                </Form.Item>
            </Col>
          <Col xs={24} lg={8}>
            <Form.Item
              label={t("stores.fields.ftpLogin")}
              name="ftp_login"
              hidden={!componentDisabled}
            >
              <Input />
            </Form.Item>           
          </Col>
          <Col xs={24} lg={8}>
            <Form.Item
              label={t("stores.fields.ftpPassword")}
              name="ftp_password"
              hidden={!componentDisabled}
            >
              <Input.Password
              iconRender={visible => (visible ? <Icons.EyeTwoTone /> : <Icons.EyeInvisibleOutlined />)}
              />
            </Form.Item>           
          </Col>
            <Col xs={24} lg={8}>
                <Form.Item
                    label={t("stores.fields.auth_method")}
                    name="auth_method"
                    hidden={!componentDisabled}
                >
                    <Input />
                </Form.Item>
            </Col>
            <Col xs={24} lg={8}>
                <Form.Item
                    label={t("stores.fields.auth_uri")}
                    name="auth_uri"
                    hidden={!componentDisabled}
                >
                    <Input />
                </Form.Item>
            </Col>
            <Col xs={24} lg={8}>
                <Form.Item
                    label={t("stores.fields.bearer_token")}
                    name="bearer_token"
                    hidden={!componentDisabled}
                >
                    <Input />
                </Form.Item>
            </Col>
            <Col xs={24} lg={8}>
                <Form.Item
                    label={t("stores.fields.auth_login")}
                    name="auth_login"
                    hidden={!componentDisabled}
                >
                    <Input />
                </Form.Item>
            </Col>
            <Col xs={24} lg={8}>
                <Form.Item
                    label={t("stores.fields.auth_pass")}
                    name="auth_pass"
                    hidden={!componentDisabled}
                >
                    <Input.Password
                        iconRender={visible => (visible ? <Icons.EyeTwoTone /> : <Icons.EyeInvisibleOutlined />)}
                    />
                </Form.Item>
            </Col>

        </Row>
        <Row gutter={[64, 0]} wrap>
          <Col xs={24} lg={24}>
            <label>{t("stores.fields.vchasno_kasa_section")}</label>
          </Col>
          <Col xs={24} lg={8}>
            <Form.Item
                label={t("stores.fields.vchasnoKasaUrl")}
                name="vchasno_kasa_url"
            >
              <Input placeholder="https://api.vchasno.ua" />
            </Form.Item>
          </Col>
          <Col xs={24} lg={8}>
            <Form.Item
                label={t("stores.fields.vchasnoKasaToken")}
                name="vchasno_kasa_token"
            >
              <Input.Password
                  iconRender={visible => (visible ? <Icons.EyeTwoTone /> : <Icons.EyeInvisibleOutlined />)}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[64, 0]} wrap>
          <Col xs={24} lg={8}>
            <Form.Item
              label={t("stores.fields.isActive")}
              name="is_active"
            >
              <Radio.Group>
                <Radio value={true}>{t("status.enable")}</Radio>
                <Radio value={false}>{t("status.disable")}</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
          <Col xs={48} lg={8}>
            <Space/>
          </Col>
        </Row>
      </Form>
    </Create>
  );
};
